import React from 'react';
import PropTypes from 'prop-types';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import ScenarioBox from '../scenarios/ScenarioBox.react';

interface ScenarioStripProps {
 absoluteUrls?: boolean;
 addButton?: any;
 onClick?: (...args: unknown[]) => unknown;
 scenarios?: any;
 title: any;
 viewAll?: any;
 viewMore?: any;
}

export default class ScenarioStrip extends React.Component<ScenarioStripProps> {
    static defaultMargin = 12;

    static propTypes = {
        absoluteUrls: PropTypes.bool,
        addButton: PropTypes.any,
        onClick: PropTypes.func,
        scenarios: PropTypes.any,
        title: PropTypes.any.isRequired,
        viewAll: PropTypes.any,
        viewMore: PropTypes.any,
    };

    constructor(props) {
        super(props);

        this.stripEl = null;

        let width = this.getWidth();
        let renderedCnt = this.computeRenderedScenarios(width);

        this.state = {
            overflowing: renderedCnt < this.getScenarios(props.scenarios).length,
            renderedScenarios: renderedCnt,
            width: width
        };
    }

    componentDidMount() {
        this.setStipOverflow();
        this.resizeListener = this.setStipOverflow.bind(this);
        window.addEventListener("resize", this.resizeListener);
    }

    updateDimensions() {
        this.setStipOverflow();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeListener);
    }

    setStipOverflow() {
        let self = this;
        let width = this.getWidth();

        if (this.stripEl) {
            setTimeout(() => {
                let renderedCnt = this.computeRenderedScenarios(width);

                self.setState({
                    overflowing: renderedCnt < self.getScenarios().length,
                    renderedScenarios: renderedCnt,
                    width: width
                });
            }, 0);
        }
    }

    getWidth() {
        let width = 0;

        if (this.stripEl) {
            width = this.stripEl.getBoundingClientRect().width;
        }
        else {
            // roughly expected box width
            width = window.innerWidth - 373;
        }

        return width;
    }

    computeRenderedScenarios(width) {
        /*
         5px for most left and most right margins
         24px for box left/right margins
         300px for box width
        */
        return Math.floor((width - 2 * 20 + 2 * ScenarioStrip.defaultMargin) / (300 + 2 * ScenarioStrip.defaultMargin));
    }

    getScenarios(passedScenarios) {
        let scenarios = passedScenarios || this.props.scenarios;

        if (scenarios.edges) {
            scenarios = scenarios.edges;
        }

        return scenarios;
    }

    getMargin() {
        let width = this.state.width;
        let boxes = this.state.renderedScenarios;
        return Math.max(ScenarioStrip.defaultMargin, Math.min((width - 2 * 5 - boxes * 300) / (boxes * 2 - 2), ScenarioStrip.defaultMargin * 3));
    }

    render() {
        let scenarios = this.getScenarios();
        let margin = '' + this.getMargin() + 'px';

        return (
            <div>
                {scenarios.length > 0 ?
                    <div>
                        <div className="sectionHeader">
                            <h3>{this.props.title}</h3>

                            {this.props.addButton || null}

                            {this.state.overflowing && this.props.viewAll ? this.props.viewAll : null}
                            {this.props.viewMore || null}
                        </div>

                        <div className="scenarioGridList scenarioStrip" ref={(el) => {this.stripEl = el;}}>
                            {scenarios.slice(0, this.state.renderedScenarios).map(({node}, idx) => {
                                let scenario = node.scenario || node;

                                let style = {};
                                style.marginLeft = idx === 0 ? '5px' : margin;
                                style.marginRight = idx === this.state.renderedScenarios - 1 ? '5px' : margin;

                                return (
                                    <ScenarioBox absoluteUrls={this.props.absoluteUrls} key={idx} metadata={types['scenarios']} onClick={this.props.onClick} scenario={scenario} style={style} urlMapping={urlMapping} />
                                );
                            })}
                        </div>
                    </div>
                : null}
            </div>
        );
    }
}
